import React, { useState } from "react";
import { SubNav, FileDropzone } from "../gc/ui";
import CodeEditorPanel from "./CodeEditorPanel";
import VisualScriptingPanel from "./VisualScriptingPanel";
import { CODE_TEMPLATES, languageFromPath, readAsText, downloadText } from "../../lib/gamecraft";
import { toast } from "sonner";

export default function CodeHub({ project, onChange }) {
  const [sub, setSub] = useState("editor");
  const files = project.files || [];
  const lang = project.config?.language || "python";

  const upload = async (list) => {
    const next = [...files];
    for (const f of list) {
      const content = await readAsText(f);
      next.push({ id: crypto.randomUUID(), path: f.name, language: languageFromPath(f.name), content });
    }
    onChange({ files: next });
    toast.success("Archivo importado");
  };

  const applyTemplates = () => {
    const pack = CODE_TEMPLATES[lang] || CODE_TEMPLATES.javascript;
    const next = [...files];
    Object.entries(pack).forEach(([path, content]) => {
      if (!next.some((f) => f.path === path)) {
        next.push({ id: crypto.randomUUID(), path, language: languageFromPath(path), content });
      }
    });
    onChange({ files: next });
    toast.success("Plantillas añadidas");
  };

  const downloadAll = () => {
    files.forEach((f) => downloadText(f.content || "", f.path.split("/").pop()));
  };

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 flex flex-wrap items-center gap-2">
        <SubNav
          items={[
            { id: "editor", label: "Editor" },
            { id: "templates", label: "Plantillas" },
            { id: "visual", label: "Visual" },
          ]}
          value={sub}
          onChange={setSub}
        />
        <FileDropzone accept=".js,.ts,.py,.gd,.cs,.lua,.json,.md,.html,.css,.txt" multiple onFiles={upload} label="Subir código" />
        <button className="gc-btn gc-btn-ghost h-9 px-3 text-xs" onClick={downloadAll}>Descargar archivos</button>
      </div>
      <div className="flex-1 min-h-0">
        {sub === "editor" && <div className="h-full gc-tool mx-4 mb-4" style={{ minHeight: 520 }}><CodeEditorPanel project={project} onChange={onChange} /></div>}
        {sub === "visual" && <VisualScriptingPanel project={project} onChange={onChange} />}
        {sub === "templates" && (
          <div className="p-4 space-y-3">
            <p className="text-sm" style={{ color: "var(--gc-muted)" }}>Plantillas para {lang}. Se añaden sin pisar archivos existentes.</p>
            <button className="gc-btn gc-btn-primary h-10 px-4" onClick={applyTemplates}>Insertar plantillas {lang}</button>
            <pre className="gc-tool p-4 text-xs overflow-auto max-h-[50vh]">
              {Object.entries(CODE_TEMPLATES[lang] || CODE_TEMPLATES.javascript).map(([k, v]) => `// ${k}\n${v}\n`).join("\n")}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
